import React, { useEffect, useState } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { Box, LinearProgress, Snackbar, MenuItem, Alert, Dialog, DialogTitle, DialogContent, Typography, Button, DialogActions, DialogContentText, Link } from '@mui/material'
import { getSubscription, setSubscriptionEnd } from "../../service/payApi"
import DoNotDisturbOutlinedIcon from '@mui/icons-material/DoNotDisturbOutlined'
import { epochToLocale } from 'utils'
interface Props {
  onCloseMenu: () => void
}
export default function CancelSubscription({ onCloseMenu }: Props) {
  const queryClient = useQueryClient()
  const [openDialog, setOpenDialog] = useState(false)
  const [busy, setBusy] = useState(false)
  const [successSnack, setSuccessSnack] = useState(false)
  const [errorSnack, setErrorSnack] = useState(false)

  const { data: sub } = useQuery({
    queryKey: ['getSubscription'], queryFn: getSubscription,
    enabled: queryClient.getQueryData(['getSubscription']) === undefined,
  })
  const periodEnd = epochToLocale(sub?.subscription?.current_period_end)
  async function onCancel() {
    setBusy(true)
    const res = await setSubscriptionEnd(true)
    if (res instanceof Error)
      setErrorSnack(true)
    else {
      setSuccessSnack(true)
      await queryClient.invalidateQueries({ queryKey: ['getSubscription'] })
      onCloseMenu()
    }
    setBusy(false)
  }

  if (sub?.subscription?.cancel_at != null)
    return null

  return (
    <>
      <MenuItem onClick={() => setOpenDialog(true)}>
        <DoNotDisturbOutlinedIcon sx={{ color: 'gray', marginRight: "15px" }} />
        Cancel Subscription
      </MenuItem>

      <Dialog open={openDialog} onClose={() => !busy && setOpenDialog(false)}>

        <DialogTitle>Cancel Confirmation</DialogTitle>
        <DialogContent>

          <DialogContentText  >
            We&apos;re sad to see you go! If there&apos;s anything we could have done better, let us know at <Link href="mailto:support@finmate.ai">support@finmate.ai</Link>.
          </DialogContentText>

          <DialogContentText>
            <br />
            If you would like to reduce the number of seats, please contact us.
          </DialogContentText>

          <DialogContentText variant='body2'>
            <br />
            Upon cancellation, your license(s) will remain active until the end of your billing cycle, {periodEnd}.
          </DialogContentText>

        </DialogContent>

        {busy && <LinearProgress />}

        <DialogActions sx={{ justifyContent: 'space-between', paddingLeft: '18px' }}>
          <Button
            aria-label='Cancel Subscription' color='warning' variant='outlined'
            onClick={onCancel} disabled={busy}
          >
            Cancel Subscription
          </Button>

          <Button aria-label='close' onClick={() => setOpenDialog(false)}
            disabled={busy}>
            Close
          </Button>
        </DialogActions>

      </Dialog >

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={successSnack} autoHideDuration={3000}
        onClose={() => setSuccessSnack(false)}
      >
        <Alert variant="filled" severity="success" >
          Subscription is Set to Cancel
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={errorSnack} autoHideDuration={3000}
        onClose={() => setErrorSnack(false)}
      >
        <Alert variant="filled" severity="error" >
          Subscription Cancelled Failed. Please Try Again, or contact support@finmate.ai
        </Alert>
      </Snackbar>
    </>
  )
}
